/**
 * 权限码常量定义
 * 与后端 sys_permission.code 保持一致
 */

export const PERMISSIONS = {
  // 数据总览
  DASHBOARD_VIEW: 'dashboard:view',

  // 数据大屏
  BIGSCREEN_VIEW: 'bigscreen:view',

  // 用户管理
  USER_LIST: 'user:list',
  USER_CREATE: 'user:create',
  USER_UPDATE: 'user:update',
  USER_DELETE: 'user:delete',
  USER_EXPORT: 'user:export',

  // 微信开放平台
  PLATFORM_VIEW: 'platform:view',

  // 其它平台
  OTHER_PLATFORM_VIEW: 'other_platform:view',

  // 代理管理
  AGENT_LIST: 'agent:list',
  AGENT_CREATE: 'agent:create',
  AGENT_UPDATE: 'agent:update',
  AGENT_DELETE: 'agent:delete',

  // 订单管理
  ORDER_VIEW: 'order:view',
  ORDER_PLAY: 'order:play',
  ORDER_CHATER: 'order:chater',
  ORDER_ALBUM: 'order:album',

  // 财务管理
  FINANCE_VIEW: 'finance:view',
  FINANCE_TRADE: 'finance:trade',
  FINANCE_SHARE: 'finance:share',
  FINANCE_CASH: 'finance:cash',
  FINANCE_REFUND_REVIEW: 'finance:refund_review',
  FINANCE_PROFIT_CONFIG: 'finance:profit_config',
  FINANCE_PROFIT_RECORD: 'finance:profit_record',
  FINANCE_SHANYAN_PROFIT_CONFIG: 'finance:shanyan_profit_config',

  // 陪聊管理
  CHATER_LIST: 'chater:list',
  CHATER_UPDATE: 'chater:update',
  CHATER_DELETE: 'chater:delete',

  // 陪玩管理
  PLAY_VIEW: 'play:view',
  PLAY_USER_LIST: 'play:user_list',
  PLAY_USER_CREATE: 'play:user_create',
  PLAY_USER_UPDATE: 'play:user_update',
  PLAY_USER_DELETE: 'play:user_delete',
  PLAY_ITEM_LIST: 'play:item_list',
  PLAY_CATEGORY_LIST: 'play:category_list',
  PLAY_COMMENT_LIST: 'play:comment_list',

  // 营销管理
  MARKETING_VIEW: 'marketing:view',
  MARKETING_COUPON: 'marketing:coupon',
  MARKETING_GIFTPACK: 'marketing:giftpack',
  MARKETING_PROMO: 'marketing:promo',

  // 城市管理
  CITY_LIST: 'city:list',
  CITY_UPDATE: 'city:update',

  // 闪颜群聊
  GROUPCHAT_LIST: 'groupchat:list',
  GROUPCHAT_SEND: 'groupchat:send',
  GROUPCHAT_PRIVATE_MESSAGE: 'groupchat:private_message',

  // 留言管理
  MESSAGE_LIST: 'message:list',

  // 审核管理
  AUDIT_VIEW: 'audit:view',
  AUDIT_PLAYER: 'audit:player',
  AUDIT_FILE: 'audit:file',
  AUDIT_ORDER_PUBLISH: 'audit:order_publish',

  // 达人视频管理
  VIDEO_MANAGE: 'video:manage',
  VIDEO_AUDIT: 'video:audit',
  VIDEO_UPLOAD: 'video:upload',
  VIDEO_QUERY: 'video:query',

  // 二维码管理
  QRCODE_LIST: 'qrcode:list',

  // 发单管理
  ORDER_PUBLISH_VIEW: 'order_publish:view',
  ORDER_PUBLISH_LIST: 'order_publish:list',
  ORDER_PUBLISH_NEARBY: 'order_publish:nearby',

  // 轨迹查询
  TRACE_VIEW: 'trace:view',

  // 系统管理
  SYSTEM_VIEW: 'system:view',
  SYSTEM_ADMIN_LIST: 'system:admin_list',
  SYSTEM_STAFF_LIST: 'system:staff_list',
  SYSTEM_STAFF_CREATE: 'system:staff_create',
  SYSTEM_STAFF_UPDATE: 'system:staff_update',
  SYSTEM_STAFF_DELETE: 'system:staff_delete',

  SYSTEM_BRANCH_ROLE_LIST: 'system:branch_role_list',
  SYSTEM_BRANCH_ROLE_CREATE: 'system:branch_role_create',
  SYSTEM_BRANCH_ROLE_UPDATE: 'system:branch_role_update',
  SYSTEM_BRANCH_ROLE_DELETE: 'system:branch_role_delete',

  SYSTEM_ROLE_PERM: 'system:role_perm',
  SYSTEM_TAG: 'system:tag',
  SYSTEM_KEYWORD: 'system:keyword',
  SYSTEM_SHARE_CONFIG: 'system:share_config',
  SYSTEM_PASSWORD: 'system:password',
  SYSTEM_NOTIFY: 'system:notify',
  SYSTEM_MESSAGE_RECEIVER: 'system:message_receiver',
  SYSTEM_MESSAGE_TEMPLATE: 'system:message_template',
  SYSTEM_VIP_PRICE: 'system:vip_price',
  SYSTEM_WITHDRAW_CONFIG: 'system:withdraw_config',
  SYSTEM_FRONT_CONFIG: 'system:front_config',
  SYSTEM_PAGE_HOTSPOT: 'system:page_hotspot',

  // 客服管理
  CUSTOMER_SERVICE_LIST: 'customer_service:list',
  CUSTOMER_SERVICE_UPDATE: 'customer_service:update',

  // 兑换码管理
  EXCHANGE_CODE_GENERATE: 'exchange_code:generate',
  EXCHANGE_CODE_LIST: 'exchange_code:list',

  // 加入团队设置
  AGENT_JOIN_SETTING: 'agent:join_setting',
  AGENT_LIMIT_SETTING: 'agent:limit_setting',

  // 活动管理
  ACTIVITY_VIEW: 'activity:view',
  ACTIVITY_LIST: 'activity:list',
  ACTIVITY_ORGANIZER_AUDIT: 'activity:organizer_audit',
}

/**
 * 菜单与权限码的映射
 * 用于前端菜单渲染时的权限判断
 */
export const MENU_PERMISSION_MAP = {
  '/': PERMISSIONS.DASHBOARD_VIEW,
  '/userList': PERMISSIONS.USER_LIST,
  '/platform': PERMISSIONS.PLATFORM_VIEW,
  '/other-platforms': PERMISSIONS.OTHER_PLATFORM_VIEW,
  '/agent': PERMISSIONS.AGENT_LIST,
  '/order': PERMISSIONS.ORDER_VIEW,
  '/finance': PERMISSIONS.FINANCE_VIEW,
  '/chater-manage': PERMISSIONS.CHATER_LIST,
  '/play': PERMISSIONS.PLAY_VIEW,
  '/play/category-list': PERMISSIONS.PLAY_CATEGORY_LIST,
  '/marketing': PERMISSIONS.MARKETING_VIEW,
  '/cities': PERMISSIONS.CITY_LIST,
  '/groupchat': PERMISSIONS.GROUPCHAT_LIST,
  '/activity': PERMISSIONS.ACTIVITY_VIEW,
  '/message-manage': PERMISSIONS.MESSAGE_LIST,
  '/audit-manage': PERMISSIONS.AUDIT_VIEW,
  '/qrcode': PERMISSIONS.QRCODE_LIST,
  '/video-manage': PERMISSIONS.VIDEO_MANAGE,
  '/video-manage/audit': PERMISSIONS.VIDEO_AUDIT,
  '/video-manage/upload': PERMISSIONS.VIDEO_UPLOAD,
  '/video-manage/query': PERMISSIONS.VIDEO_QUERY,
  '/order-publish': PERMISSIONS.ORDER_PUBLISH_VIEW,
  '/trace': PERMISSIONS.TRACE_VIEW,
  '/system': PERMISSIONS.SYSTEM_VIEW,
  '/front-config': PERMISSIONS.SYSTEM_FRONT_CONFIG,
  '/system/customer-service': PERMISSIONS.CUSTOMER_SERVICE_LIST,
}

/**
 * 角色枚举（与后端 sys_admin.role 对应）
 */
export const ROLES = {
  ADMIN: 1,      // 管理员
  CS: 2,         // 客服
  FINANCE: 3,    // 财务
  SUPER: 4,      // 超级管理员
  AGENT: 5,      // 代理管理员
}

export const ROLE_LABELS = {
  [ROLES.ADMIN]: '管理员',
  [ROLES.CS]: '客服',
  [ROLES.FINANCE]: '财务',
  [ROLES.SUPER]: '超级管理员',
  [ROLES.AGENT]: '代理管理员',
}
